export const GameVideo = () => {
  return (
    <>
          

          <iframe width="860" height="500" src="https://divineconquer.online/bg/bg.gif" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
    </>
  );
};
